import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/download/share.png'
import _imports_1 from '@/assets/download/dataUse.png'
import _imports_2 from '@/assets/download/lock.png'
import _imports_3 from '@/assets/download/trash.png'


const _hoisted_1 = { style: {"margin":"0","font-size":"15px"} }
const _hoisted_2 = { style: {"margin":"0","font-size":"15px"} }
const _hoisted_3 = { style: {"margin":"0","font-size":"15px"} }
const _hoisted_4 = { style: {"margin":"0","font-size":"15px"} }

import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'SecurityList',
  props: {
    img: {
        type: String,
        default: 'share'
    }
},
  setup(__props) {

const props = __props
const { t } = useI18n();
const dataShare = computed(() => [t('download.dataShare'), t('download.datShareLearn')])
const dataUse = computed(() => [t('download.collectData'), t('download.appActivity')])
const dataLock = computed(() => [t('download.dataEncrypt')])
const dataRemove = computed(() => [t('download.reqDelete')])


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_row, { style: {"padding":"10px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: 4 }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"flex-start"} }, [
              _createElementVNode("img", {
                style: {"width":"35%","object-fit":"cover","border-radius":"10px"},
                src: _imports_0
              })
            ], -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, { span: 20 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataShare.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"height":"25px","color":"#5f6368","display":"flex","justify-content":"flex-start","align-items":"center"}
              }, [
                _createElementVNode("p", _hoisted_1, _toDisplayString(item), 1)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { style: {"padding":"10px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: 4 }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"flex-start"} }, [
              _createElementVNode("img", {
                style: {"width":"35%","object-fit":"cover","border-radius":"10px"},
                src: _imports_1
              })
            ], -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, { span: 20 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataUse.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"color":"#5f6368","display":"flex","justify-content":"flex-start","align-items":"center"}
              }, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(item), 1)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { style: {"padding":"10px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: 4 }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"flex-start"} }, [
              _createElementVNode("img", {
                style: {"width":"35%","object-fit":"cover","border-radius":"10px"},
                src: _imports_2
              })
            ], -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, { span: 20 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataLock.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"color":"#5f6368","display":"flex","justify-content":"flex-start","align-items":"center"}
              }, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(item), 1)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { style: {"padding":"10px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: 4 }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"flex-start"} }, [
              _createElementVNode("img", {
                style: {"width":"35%","object-fit":"cover","border-radius":"10px"},
                src: _imports_3
              })
            ], -1)
          ])),
          _: 1
        }),
        _createVNode(_component_van_col, { span: 20 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataRemove.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"color":"#5f6368","display":"flex","justify-content":"flex-start","align-items":"center"}
              }, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(item), 1)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})